import { useEffect, useState } from 'react'


function convertUid(s: string): string {
    return s?.replace("-", "_").toLowerCase()
}

function generateUid(object): string {
    const well_uid = convertUid(object.uidWell);
    const wellbore_uid = convertUid(object.uidWellbore);
    const trajectory_uid = convertUid(object.uidObject);
    const object_type = 'trajectory'
    const uid = `raw_witsml_store_${well_uid}_${wellbore_uid}_${object_type}_${trajectory_uid}`

    return uid
}

export default function loadObjects({ asset, objectType }: { asset: string; objectType: string }) {
    const [objects, setObjects] = useState([])

    useEffect(() => {
        if (asset) {
            const url = objectType === 'trajectory' ? `/services/plugin-object-list-service/witsmlobjectlist/well/${asset}/object/${objectType}` : `/services/plugin-drilling-widgets/objects/${asset}/${objectType}`
            const controller = new AbortController()
            const signal = controller.signal
            fetch(url, {
                signal
            })
                .then(r => r.json())
                .then((r: any[]) => {
                    if (Array.isArray(r)) {
                        const objects = objectType === 'trajectory' ? r.map(o => ({ name: o.nameObject, object: objectType, uid: generateUid(o) })) : r
                        setObjects(objects)
                    }
                })
                .catch(e => {
                    console.error(e)
                })

            return () => controller.abort()
        }
    }, [asset, objectType])

    return objects
}
